<template>
  <div>
    <Loading v-if="loading" />
    <div v-if="isAuthenticated">
      <AppHeader />

      <section class="main-menu navbar-space">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="secondary-title">
                <h5 class="title">ยืนยันการอนุมัติให้ใช้วงเงินและหักค่าธรรมเนียม</h5>
              </div>
            </div>
          </div>
          <div v-if="taskList.length > 0" class="row justify-content-center">
            <div class="col-12 col-xs-fix">
              <div class="purchase-table-wrapper table-wrapper">
                <table class="purchase-table table">
                  <thead>
                    <tr>
                      <th scope="col">หมายเลขอ้างอิง</th>
                      <th scope="col">ประเภทรายการ</th>    
                      <th scope="col">ประเภทการค้ำประกัน</th>
                      <th scope="col">วันที่ทำรายการ</th>
                      <th class="amt-th" scope="col">จำนวนเงินค้ำประกัน(บาท)</th>
                      <th scope="col">ชื่อผู้รับผลประโยชน์</th>
                      <th scope="col">Tax Id ผู้ขอออก</th> 
                      <th scope="col">ผู้ขอออก</th>
                      <th scope="col">Tax Id ผู้ค้ำประกันในนาม</th>
                      <th scope="col">ชื่อผู้ค้ำประกันในนาม</th>
                      <th scope="col">หมายเลขบัญชีวงเงิน</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="main-row"
                      v-for="(item, index) in taskList"
                      v-bind:item="item"
                      v-bind:index="index"
                      v-bind:key="item.requestId"
                    >
                      <td class="name-cell" >
                        <a @click="getTaskDetail(item.requestId)"><font color="#008ec4"><u>{{item.requestId}}</u></font></a>
                      </td>
                      <td class="name-cell"  width="150%"> {{reqTypeMapping(item.reqType)}} </td>
                      <td class="name-cell">{{item.contingentTypeNameTh}}</td>
                      <td class="date-cell">{{item.docCreateDate}}</td>
                      <td class="amt-cell">
                        <span class="amt-cur">{{formatPrice(item.lgAmt)}}</span>
                      </td>
                      <td class="name-cell">{{item.beneNameTh}}</td>
                       <td class="name-cell">{{item.requesterTaxId}}</td> 
                      <td class="name-cell">{{item.requesterNameTh}}</td>
                      <td class="name-cell">
                      <template  v-for="r in item.taskRequesterVoList">
                       {{ r.guaranteeTaxId}},
                      </template>
                      </td>
                      <td class="name-cell">
                      <template  v-for="r in item.taskRequesterVoList">
                       {{r.guaranteeName}},
                      </template>
                      </td>
                      <td class="name-cell">{{item.commNo}}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <b-pagination
              size="md"
              :total-rows="totalRecord"
              v-model="currentPage"
              :per-page="10"
              @input="getTaskList(currentPage)"
            ></b-pagination>
          </div>
          <div v-if="taskList.length === 0" class="row justify-content-center">
            <div class="col-12 col-xs-fix">
              <div class="purchase-table-wrapper table-wrapper">
                <table class="purchase-table table">
                  <thead>
                    <tr>
                      <th scope="col">หมายเลขอ้างอิงรายการ</th>
                      <th scope="col">ประเภทธุรกรรม</th>    
                      <th scope="col">ประเภทการค้ำประกัน</th>
                      <th scope="col">วันที่ทำรายการ</th>
                      <th class="amt-th" scope="col">วงเงินค้ำประกัน(บาท)</th>
                      <th scope="col">ชื่อผู้รับผลประโยชน์</th>
                      <th scope="col">Tax Id ผู้ขอออก</th> 
                      <th scope="col">ชื่อผู้ขอออก</th>
                      <th scope="col">Tax Id ผู้ค้ำประกันในนาม</th>
                      <th scope="col">ชื่อผู้ค้ำประกันในนาม</th>
                      <th scope="col">หมายเลขบัญชีวงเงิน</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="empty-data">
                      <td colspan="999">ไม่มีข้อมูลรออนุมัติ</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { mapGetters } from "vuex";
import { apiClient } from "@/utils/apiClient";
import moment from "moment";
//import modal from "./modal";

export default {
  components: {
    AppFooter,
    AppHeader,
    //modal
  },
  name: "TaskList",

  data() {
    return {
      taskList: [
        {
          taskId: "",
          requestId: ""
        }
      ],
      currentPage: 1,
      limitPage: 10,
      totalRecord: 0,
      taskVo: null,
      selected: [],
      //modalOpen: false
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    }
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      //return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return value === "" || value === undefined
        ? ""
        :val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatDate: function(number) {
      return number === "" || number === undefined
        ? ""
        : moment(String(number)).format("DD/MM/YYYY");
    },
    reqTypeMapping(tmpReqType) {
      let returnType = "";
      if (tmpReqType === "NEW") {
        returnType = "ออกหนังสือค้ำประกัน";
      } else if (tmpReqType === "INC") {
        returnType = "เพิ่มวงเงินหนังสือค้ำประกัน";
      } else if (tmpReqType === "EXT") {
        returnType = "ต่ออายุหนังสือค้ำประกัน";
      } else if (tmpReqType === "EXTINC") {
        returnType = "ต่ออายุ+เพิ่มวงเงิน";
      }

      return returnType;
    },
    getTaskList: function(currentPage) {
      this.loader = this.$loading.show();
      apiClient
        .get("/api/task/getTaskList/" + currentPage + "/" + this.limitPage)
        .then(resp => {
          this.taskList = resp.data.list;
          this.totalRecord = resp.data.fullListSize;
          this.loader.hide();
          window.scrollTo(0, 0);
        })
        .catch(err => {
          if(err.response.status===401){
            this.loader.hide();
          }
        //  this.$swal("Error!", "" + err, "error");
        });
    },
    getTaskDetail: function(requestId) {
      this.loader = this.$loading.show();
      apiClient
        .get("/api/task/getTaskHistoryDetail/" + requestId)
        .then(resp => {

          let taskVo = resp.data;
          const feeDebitAccountList = taskVo.feeDebitAccountList;

          var periodDateStr = "";
          var strTest = "<select  id='feeDebitAcc'   class='form-control'>";
          for (var i = 0; i < feeDebitAccountList.length; i++) {
            strTest +=
              "<option value='" +
              feeDebitAccountList[i].accountNo +
              "'>" +
              feeDebitAccountList[i].accountNo +
              "-" +
              feeDebitAccountList[i].accountName +
              "</option>";
          }
          strTest += "</select>";

          if (taskVo.periodEndDate.length > 0) {            
            periodDateStr = taskVo.periodStartDate + " ถึง " + taskVo.periodEndDate;
          } else {
            periodDateStr = taskVo.periodStartDate;
          }

          var strRequest = "";
          var reqTypeStr =  this.reqTypeMapping(taskVo.reqType);
          if (
            taskVo.taskRequesterVoList != null &&
            taskVo.taskRequesterVoList.length > 0
          ) {
            for (var i = 0; i < taskVo.taskRequesterVoList.length; i++) {
              strRequest =
                strRequest +
                taskVo.taskRequesterVoList[i].guaranteeTaxId +
                " : " +
                taskVo.taskRequesterVoList[i].guaranteeName +
                "<br/>";
            }
          }

          var strStamp = "";
          if(taskVo.reqType === "NEW"){
            strStamp = "15.00";
          }

          this.$swal.fire({
            title:
              "<h4><b>รายละเอียดการอนุมัติให้ใช้วงเงินและหักค่าธรรมเนียม</b></h4>",
            width: 600,
            html:
              "<div class='card-body compact-padding'>" +
              "   <div class='default-padding'>" +
              "      <div class='form-row'>" +
              "         <div class='form-group-sum col-md-5'>" +
              "            <label>หมายเลขอ้างอิงรายการ</label>" +
              "       </div>" +
              "      <div class='text-sum col-md-7'>" +
              taskVo.requestId +
              "    </div>" +
              "</div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ประเภทธุรกรรม</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              reqTypeStr +
              " </div>" +
              " </div>" +
              " <div class='form-row'>" +
              "    <div class='form-group-sum col-md-5'>" +
              "       <label>ผู้ขอออกหนังสือค้ำประกัน</label>" +
              "  </div>" +
              " <div class='text-sum col-md-7'>" +
              taskVo.requesterTaxId +
              " " +
              taskVo.requesterNameTh +
              "</div>" +
              "</div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>สถานะ</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              taskVo.statusDesc +
              "</div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ผู้รับผลประโยชน์</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              taskVo.beneTaxId +
              " " +
              taskVo.beneNameTh +
              "</div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ประเภทการค้ำประกัน</label>" +
              " </div>" +
              " <div class='text-sum col-md-7'>" +
              taskVo.contingentTypeNameTh +
              "</div>" +
              " </div>" +
              " <div class='form-row'>" +
              "    <div class='form-group-sum col-md-5'>" +
              "       <label>เพื่อค้ำประกันในนาม</label>" +
              "  </div>" +
              " <div class='text-sum col-md-7'>" +
              strRequest +
              "</div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>จำนวนเงินค้ำประกัน (บาท)</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              this.formatPrice(taskVo.lgAmt) +
              " </div>" +
              "</div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>มีผลบังคับใช้ตั้งแต่วันที่</label>" +
              " </div>" +
              " <div class='text-sum col-md-7'>" +
              periodDateStr +
              " </div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>วันที่ทำรายการ</label>" +
              " </div>" +
              " <div class='text-sum col-md-7'>" +
              taskVo.docCreateDate +
              " </div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>หมายเลขบัญชีวงเงิน</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              taskVo.commNo +
              "      </div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ชื่อบัญชีวงเงิน</label>" +
              " </div>" +
              " <div class='text-sum col-md-7'>" +
              taskVo.commName +
              "</div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>บัญชีหักค่าธรรมเนียม</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              strTest +
              "</div>" +
              "</div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ค่าธรรมเนียม (บาท)</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              "ค่าธรรมเนียมขั้นต่ำ 500 บาท หรือเป็นไปตามระเบียบธนาคาร" +
              "</div>" +
              "</div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ค่าอากรแสตมป์ (บาท)</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              strStamp +
              "</div>" +
              "</div>" +
              " " +
              "<div class='d-flex justify-content-center mt-4'> " +
              "   <div class='row-fluid'>" +
              "      <button id='btnApprove' class='btn btn-sm btn-primary-ktb' type='button'>อนุมัติ</button> " +
              "      <button id='btnReject' class='btn btn-sm btn-primary-ktb' type='button'>ไม่อนุมัติ</button>" +
              "      <button id='btnCancal' class='btn btn-sm btn-danger'  type='button'>ยกเลิก</button>" +
              "   </div>" +
              "</div>",

            //type: 'warning',
            showCancelButton: false,
            showConfirmButton: false,
            // confirmButtonColor: "#3085d6",
            // confirmButtonText: "ปิดรายละเอียด",
            onBeforeOpen: () => {
              const content = this.$swal.getContent();
              const $ = content.querySelector.bind(content);
              const approve = $("#btnApprove");
              const reject = $("#btnReject");
              const cancel = $("#btnCancal");
              const feeDebitAcc = $("#feeDebitAcc");

              approve.addEventListener("click", () => {
                let feeDebitAccName =
                  feeDebitAcc[feeDebitAcc.selectedIndex].text;

                if (feeDebitAccName.indexOf("-") > -1) {
                  feeDebitAccName = feeDebitAccName.split("-")[1];
                }
                this.$swal
                    .fire({
                      title: "",
                      width: 400,
                      html:
                        "ยืนยันอนุมัติการใช้วงเงินใช่หรือไม่",
                      type: "",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      cancelButtonText: "ไม่ใช่",
                      confirmButtonText: "ใช่"
                    })
                    .then(result => {
                      if (result.value) {
                      this.$swal.close();
                      this.approve(
                        taskVo.requestId,
                        feeDebitAcc[feeDebitAcc.selectedIndex].value,
                        feeDebitAccName
                      );
                      }
                    });  
              });

              reject.addEventListener("click", () => {
                let feeDebitAccName =
                  feeDebitAcc[feeDebitAcc.selectedIndex].text;

                if (feeDebitAccName.indexOf("-") > -1) {
                  feeDebitAccName = feeDebitAccName.split("-")[1];
                }
                this.$swal
                    .fire({
                      title: "",
                      width: 400,
                      html:
                        "ยืนยันไม่อนุมัติการใช้วงเงินใช่หรือไม่",
                      type: "",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      cancelButtonText: "ไม่ใช่",
                      confirmButtonText: "ใช่"
                    })
                    .then(result => {
                      if (result.value) {
                      this.$swal.close();
                      this.reject(
                        taskVo.requestId,
                        feeDebitAcc[feeDebitAcc.selectedIndex].value,
                        feeDebitAccName
                      );
                      }
                    }); 
              });

              cancel.addEventListener("click", () => {
                this.$swal.close();
              });
            }
          });

          this.loader.hide();
        })
        .catch(err => {
          this.loader.hide();
          this.$swal("Error!", "" + err, "error");
        });
    },
    approve: function(requestId, feeDebitAcc, feeDebitAccName) {
      apiClient
        .post("/api/task/approve/" + requestId, {
          accountNo: feeDebitAcc,
          accountName: feeDebitAccName
        })
        .then(response => {
          if(response.data === ''){
            this.getTaskList(this.currentPage);
          }else{
            this.$swal("Error", response.data, "error");
          }
          
        })
        .catch(err => {
          this.loader.hide();
          this.$swal("Error!", "" + err, "error");
        });
    },
    reject: function(requestId, feeDebitAcc, feeDebitAccName) {
      apiClient
        .post("/api/task/reject/" + requestId, {
          accountNo: feeDebitAcc,
          accountName: feeDebitAccName
        })
        .then(response => {
           if(response.data === ''){
             this.getTaskList(this.currentPage);
           }else{
            this.$swal("Error", response.data, "error");
          }
        })
        .catch(err => {
          this.loader.hide();
          this.$swal("Error!", "" + err, "error");
        });
    }
  },
  mounted() {
    this.getTaskList(this.currentPage);
  }
};
</script>